var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { parse } from 'cookie';
import introspectionQueryResultData from '../../../public/fragmentTypes.json';
var fragmentMatcher = new IntrospectionFragmentMatcher({ introspectionQueryResultData: introspectionQueryResultData });
// HTTP connection to the API
var httpLink = createHttpLink({
    uri: process.env.MIX_GRAPHQL_URI,
});
var authLink = setContext(function (_, _a) {
    var headers = _a.headers;
    // const token = localStorage.getItem('token');
    var token = parse(document.cookie || '')['XSRF-TOKEN'];
    // return the headers to the context so httpLink can read them
    return {
        headers: __assign(__assign({}, headers), { 'X-XSRF-TOKEN': token }),
    };
});
// Create the apollo client
var apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache({ fragmentMatcher: fragmentMatcher }),
    defaultOptions: {
        query: {
            fetchPolicy: "network-only",
        }
    }
});
export default apolloClient;
